import { render, staticRenderFns } from "./CampaignSettingsExample.vue?vue&type=template&id=9f794e7a&scoped=true&"
import script from "./CampaignSettingsExample.vue?vue&type=script&lang=ts&"
export * from "./CampaignSettingsExample.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignSettingsExample.vue?vue&type=style&index=0&id=9f794e7a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f794e7a",
  null
  
)

export default component.exports